interface DataRowProps {
  label: string
  value: React.ReactNode
  muted?: boolean
}

export const DataRow = ({ label, value, muted }: DataRowProps) => (
  <div
    className={`flex justify-between items-baseline py-1 border-b border-border last:border-b-0 text-sm ${muted ? "opacity-60" : ""}`}
  >
    <span className="text-muted-foreground">{label}</span>
    <span className="text-foreground font-medium text-right">{value}</span>
  </div>
)
